import { create } from 'zustand';

export type ProfileSettingProps = {
    infosSaved: boolean;
    isProfileSettings: boolean;
    toggleProfileSettings: () => void;
    informationsSaved: () => void;
    closeInfosSaved: () => void;
};

export const useProfileSettings = create<ProfileSettingProps>((set, get) => ({
    infosSaved: false,
    isProfileSettings: false,
    toggleProfileSettings: () => set((state) => ({ isProfileSettings: !state.isProfileSettings })),
    informationsSaved: () => {
        set({ infosSaved: true });
        get().toggleProfileSettings();
        setTimeout(() => {
            set({ infosSaved: false });
        }, 2000);
    },
    closeInfosSaved: () => set({ infosSaved: false }),
}));
